import {Flow} from "../../../../lib/src/api/repositories/flows-repository";
import {FC, useState} from "react";
import {Button} from "../../../../lib/src/components/form/Button";
import {useApiCall} from "../../../../lib/src/api";
import {config} from "../../config";
import './FlowEditor/floweditor.css'
import {Input} from "../../../../lib/src/components/form/Input";
import {Toggle} from "../../../../lib/src/components/form/Toggle";
export const FlowDetailsForm: FC<{isLoading: boolean, flow: Flow, reload: () => void}> = props => {
  const {flows} = useApiCall(config)
  const [name, setName] = useState(props.flow.name)
  const [enabled, setEnabled] = useState(props.flow.enabled)
  const [dirty, setDirty] = useState(false)

  const save = async () => {
    await flows.updateFlowFields(props.flow.id, name, enabled)
    props.reload()
  }
  const cancel = async () => {
    setName(props.flow.name)
    setEnabled(props.flow.enabled)
    setDirty(false)
  }

  return <div className={'py-4 rounded-lg bg-white border-2 border-slate-100'}>
    <div className={'px-4 max-w-md flex flex-col gap-4'}>
      <Input type={'text'} label={'Naam'} value={name} onChange={(n) => {
        setName(n)
        setDirty(true)
      }} />
      <Toggle label={'Flow actief'} value={enabled} onChange={(e) => {
        setEnabled(e)
        setDirty(true)
      }} />
    </div>
    {dirty && <div className={'px-4 pt-4 mt-4 border-t border-slate-200 bg-white -mb-4 pb-4 rounded-b-lg flex items-center space-x-2'}>
      <Button type={'primary'} size={'sm'} text={'Wijzigingen opslaan'} onClick={save} />
      <Button type={'secondary'} size={'sm'} text={'Annuleren'} onClick={cancel} />
    </div>}
  </div>
}
